import React from 'react';
import PrivacyTermsContent from '../components/PrivacyTermsContent.jsx';
import '../styles/privacy-terms.css';

export default function PrivacyTerms() {
  return (
    <div className="privacy-terms-page">
      <div className="privacy-terms-header">
        <h1>Privacy &amp; Terms</h1>
        <p>Your privacy, data, and event details in one clear summary.</p>
      </div>
      <div className="privacy-terms-body modal-body">
        <PrivacyTermsContent />
      </div>
    </div>
  );
}

